import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  VerificationStatus,
  VerificationType,
} from 'src/common/models/verificationModels';
import { useBeforeUnload } from 'src/pages/VerificationPage/useBeforeUnload';
import { toast } from 'react-toastify';
import { RedirectionToChannelToast } from 'src/pages/VerificationPage/components/RedirectionToChannelToast';
import { toastOptions } from 'src/common/components/Toast/config';
import { AspspSelectPageRoute, verificationIdParam } from 'src/routes';
import { useStatusOfVerificationIntervalQuery } from 'src/pages/VerificationPage/verificationQueries';
import { useVerificationId } from 'src/common/hooks/useVerificationId';
import { toErrorResponse } from 'src/common/services/errors';
import { useQueryClient } from '@tanstack/react-query';
import { VerificationPageRetryablePartnerFlow } from './VerificationPageRetryablePartnerFlow';
import { VerificationPageSuccessPageFlow } from './VerificationPageSuccessPageFlow';
import { ProcessFlow } from '../../../../common/services/process';

export const openConnectorParam = 'openConnector';
export const frontendTypeParam = 'frontendType';

// todo: This requires bigger refactoring with flow analysis, most likely pooling should be on parent component "VerificationPage" with Retry modal
export const VerificationPageFlow = ({
  callbackError,
  isCallbackFetched,
  param,
  processFlow,
}: {
  callbackError: unknown;
  isCallbackFetched: boolean;
  param: string | undefined;
  processFlow: ProcessFlow | undefined;
}) => {
  const id = useVerificationId();

  const queryClient = useQueryClient();
  const history = useHistory();

  const status = useStatusOfVerificationIntervalQuery({
    verificationId: id,
    enabled: param ? isCallbackFetched : true,
  });

  useBeforeUnload(status.data?.verificationStatus);

  useEffect(() => {
    const verificationStatus = status.data?.verificationStatus;

    // Check status after callback request
    if (callbackError && status.isFetchedAfterMount) {
      if (verificationStatus === VerificationStatus.AspspsSelected) {
        toast(<RedirectionToChannelToast />, { ...toastOptions });
        queryClient.clear();
        history.replace({
          pathname: AspspSelectPageRoute,
          search: `?${verificationIdParam}=${id}&${openConnectorParam}=${VerificationType.Scrapper}`,
        });
      } else {
        toErrorResponse(callbackError, verificationStatus);
      }
    }
  }, [
    !!callbackError,
    status.data?.verificationStatus,
    status.isFetchedAfterMount,
  ]);

  return processFlow == ProcessFlow.PartnerPage ? (
    <VerificationPageRetryablePartnerFlow
      verificationStatus={status.data?.verificationStatus}
    />
  ) : (
    <VerificationPageSuccessPageFlow
      verificationStatus={status.data?.verificationStatus}
    />
  );
};
